export enum PasswordErrors {
  EMPTY = 'EMPTY',
  SHORT = 'SHORT',
}
